
import _groupBy from "lodash/groupBy";
import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import Event from "~/entities/Event";

export interface eventObjectI {
  year: any;
  events: any[];
}

export default Vue.extend({
  data() {
    return {
      $: this as any,
      upcomingEvents: [] as any[],
      previousEvents: [] as any[],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ] as string[],
      title: "Cycling and Racing Calendar of Events",
      date: new Date(),
      order: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ] as string[],
    };
  },
  head() {
    return {
      title: `${this.title} ${this.date.getFullYear()} - Bikeflights.com`,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      events: "eventShipping/events",
      currentEvent: "eventShipping/currentEvent",
    }),
  },
  methods: {
    ...mapActions({
      getEvents: "eventShipping/getEvents",
    }),
    ...mapMutations({
      setCurrentEvent: "eventShipping/setCurrentEvent",
      setEventId: "eventShipping/setEventId",
    }),
    getDay(date: string) {
      let startDate = new Date(date);
      return startDate.getDate();
    },
    getMonth(date: string) {
      let startDate = new Date(date);
      return startDate.getMonth();
    },
    goToEvent(event: Event) {
      this.setCurrentEvent(event);
      this.setEventId(event.eventId);
    },
  },
  created() {
    this.getEvents();
    this.setEventId(undefined);
  },
  watch: {
    events(newVal: Event[]) {
      this.events.forEach((event: Event) => {
        let startDate = new Date(event.startDate);
        let endDate = new Date(event.endDate);
        let currentDate = new Date();
        let parseDate = new Date(currentDate.toISOString().split("T")[0]);
        let month = startDate.getMonth();

        if (typeof month === "number") {
          if (endDate > parseDate) {
            let eventInMonth: Event[] =
              this.upcomingEvents && this.upcomingEvents.constructor === Array
                ? this.upcomingEvents
                : [];
            this.upcomingEvents = [...eventInMonth, event];
          } else {
            let eventInMonth =
              this.previousEvents && this.previousEvents.constructor === Array
                ? this.previousEvents
                : [];
            this.previousEvents = [...eventInMonth, event];
          }
        }
      });
      let events = _groupBy(this.upcomingEvents, function (event) {
        return event.startDate.substring(0, 4);
      });
      for (let i in events) {
        let e = parseInt(i);
        events[e] = _groupBy(events[e], function (event) {
          return event.startDate.substring(5, 7);
        });
      }
      this.upcomingEvents = events;
      Object.keys(this.upcomingEvents).map((year) => {
        Object.keys(this.upcomingEvents[year]).map((month) => {
          this.upcomingEvents[year][month] = this.upcomingEvents[year][
            month
          ].sort((a: Event, b: Event) => {
            return +new Date(a.startDate) - +new Date(b.startDate);
          });
        });
      });
      this.previousEvents.sort(function (a: Event, b: Event) {
        return +new Date(b.endDate) - +new Date(a.endDate);
      });
    },
  },
});
